import { FilterArtists } from './filter/filter-artists';
import {ArtistsSortDropDown} from "./sort/artists-sort-drop-down";
import {IPanelProps} from "../interfaces/interfaces";

/**
 * jPList top panel.
 */
export const TopPanelArtists = (props:IPanelProps) => {

    return (
        <div className="md:border-b mb-10 pb-2 flex flex-col md:flex-row items-center w-full">
            <div className="flex justify-between items-center flex-1 max-w-full">
                <div className="lg:ml-auto md:mr-4">
                    <ArtistsSortDropDown width={props.width}/>
                </div>
                <div className="lg:mx-4 md:block">
                    <FilterArtists />
                </div>
            </div>
        </div>

    )
};